import { useState } from 'react'
import { Grid2, Typography } from '@mui/material'
import { Field } from 'formik'
import TableFilterTemplate from '../../../shared/utils/TableFilterTemplate';
import { useAdminZoneReport } from '../../../assets/api/useAdminApi';
import { DateFormField } from '../../../shared/components/formfields/DataFormField';

const ZoneReports = () => {
    const [filters, setFilters] = useState({});
    const { data: zoneReports, isLoading: isZoneReportLoading } = useAdminZoneReport(filters)


    const zoneReportColumn = [
        {
            field: "sr_no",
            headerName: "Sr No",
            flex: 1,
            renderCell: (params) => <Typography variant="body2">{params.value}</Typography>

        },
        {
            field: "apartment_name",
            headerName: "Apartment Name",
            flex: 1,
            renderCell: (params) => <Typography variant="body2">{params.value}</Typography>,
        },
        {
            field: "attendance_count",
            headerName: "Attendance Count",
            flex: 1,
            renderCell: (params) => <Typography variant="body2">{params.value}</Typography>,
        },
        {
            field: "course_name",
            headerName: "Course Name",
            flex: 1,
            renderCell: (params) => <Typography variant="body2">{params.value}</Typography>,
        },
        {
            field: "report_date",
            headerName: "Report Date",
            flex: 1,
            renderCell: (params) => <Typography variant="body2">{params.value}</Typography>,
        },
          {
            field: "total_enquiries",
            headerName: "Total Enquiry",
            flex: 1,
            renderCell: (params) => <Typography variant="body2">{params.value}</Typography>,
        },
          {
            field: "trainer_name",
            headerName: "Trainer Name",
            flex: 1,
            renderCell: (params) => <Typography variant="body2">{params.value}</Typography>,
        }
    ];

    return (
        <>
            <TableFilterTemplate
                title="Zone Report"
                columns={zoneReportColumn}
                rowsData={zoneReports?.data || []}
                isLoading={isZoneReportLoading}
                filterInitialValues={filters}
                filterReset={() => setFilters({})}
                onApplyFilters={(f) => setFilters(f)}

                renderFilterFields={({ values }) => (
                    <>
                        <Grid2 children size={12}>
                            <Field
                                name="from"
                                component={DateFormField}
                                label="Start Date"
                                maxDate={values?.to || undefined}

                            />
                        </Grid2>
                        <Grid2 children size={12}>
                            <Field
                                name="to"
                                component={DateFormField}
                                label="End Date"
                                minDate={values?.from || undefined}

                            />
                        </Grid2>
                    </>
                )}
            />
        </>
    )
}

export default ZoneReports